import HelpIcon from '@material-ui/icons/Help';
import { useAppSelector } from '../../store';
import { Colors, DialogBox, SubtitleText, TitleText } from '../controls/helpers';

const ConfirmSend = ({ cancel, ok, open, onlyKiwiSaver }: { cancel: () => void; ok: () => void; open: boolean; onlyKiwiSaver: boolean; }) => {
    const { isSubmitting } = useAppSelector(state => state.adviser);
    return <DialogBox
        open={open}
        icon={<HelpIcon htmlColor={Colors.Green} />}
        ok={ok}
        cancel={cancel}
        isSubmitting={isSubmitting}>
        <TitleText hideMarginBottom>I confirm that:</TitleText>
        <SubtitleText black hideMarginBottom>
            <ul>
                <li>I have provided the client with required disclosures.</li>
                {onlyKiwiSaver ? <>
                        <li>I have the client's consent to pre-populate their personal details.</li>
                        <li>If applicable, I have provided an explanation of the risks of transferring schemes.</li>
                    </> : <>
                        <li>I have the competence, knowledge and skill for the advice I am providing.</li>
                        <li>If transferring the client from another KiwiSaver scheme, I have provided an explanation of the risks of transferring schemes.</li>
                        <li>My interactions with the client are not an 'uninvited direct sale' or an 'unsolicited sale'.</li>
                    </>
                }
                <li>I have no reason to believe the client is vulnerable or incapable of assessing the risk of investing.</li>
            </ul>
        </SubtitleText>
    </DialogBox>
}

export default ConfirmSend;
